import MembershipOrdersList from './MembershipOrdersList';

export default MembershipOrdersList;
